
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import rem from "@/utils/rem.js";

export default defineComponent({
  name: 'TheItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    storeKeyword: {
      type: String,
      default: ''
    },
    storeLabel: {
      type: String,
      default: '商品'
    },
    storeId: {
      type: String,
      default: '1'
    }
  },
  components: {
  },
  setup(props) {
    rem(375, 375)
    const router = useRouter()
    const store = useStore()
    const toStore = (item) => {
     window.location.href = item.productDetailUrl
    }
    return {
      toStore
    }
  }
})
